import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Radio, RadioGroup, TextField, Typography } from "@mui/material"
import { env } from "../../../../core/Env"
import { rqx } from "../../../../core/request/API"
import { Payment } from "./Payment"
import { AddBox1 } from "../../../../core/global/Icons"

export const Create = ({setup_state, tool_state, readTrainings}) => {
    const { __SESSION, userId } = tool_state
	const { trainingForm, paymentInfo, dfltPaymentInfo } = setup_state
    const inputs = trainingForm.data
	const payment = paymentInfo.data 
	
    const handlerChange = (e) => {
        const { name, value, checked } = e.target
        trainingForm.set({...inputs, [name] : value})
        if (name === 'training_date') {
            trainingForm.set({...inputs, 'training_date' : value < inputs.date_today ?  inputs.date_today : value})
        }
        if (name === "show_shop" || name === "active") {
            trainingForm.set({...inputs, [name] : checked})
        }
    }
	
	const handleAddFeeType = () => {
		if (payment.length < 10) {
			paymentInfo.set(p => [ ...p, { ...dfltPaymentInfo.data, temp_id: crypto.randomUUID() } ])
		}
	}

    const handlerCancel = () => {
        trainingForm.set({...inputs, open: false})
		paymentInfo.set([dfltPaymentInfo.data])
    }

    const handlerSave = () => {
		const errors = {};
		// const pymntRequired = ['general', 'corporate', 'cpa', 'nonCPA']
        const required = [
            'code',
            'training_date',
            'training_start',
            'training_end',
            'training_fee',
            'training_name',
            'training_type',
            'location'
        ]
        if (inputs.training_type === 'online' || inputs.training_type === 'f2f_online') {
            required.push('meeting_link', 'meeting_id', 'meeting_pass');
        }
        if (inputs.training_fee === 'with_payment') {
			payment.forEach(v => {
				if (v.name.trim() === "" || !v.regularPrice || v.price < 0) {
					errors[v.name] = `${v.name} is required`;
				}
			})
			const names = payment.map(v => v.name.trim().toLowerCase())
			const hasDuplicate = new Set(names).size !== names.length
			if (hasDuplicate) errors.hasDuplicate = 'Duplicate names are not allowed'
        }
        required.forEach(field => {
            if (!inputs[field] || inputs[field].trim() === "") {
                errors[field] = `${field} is required`;
            }
        })
        if (Object.keys(errors).length > 0) {
            console.log("Validation failed:", errors);
            trainingForm.set({...inputs, error : true})
            return; // Don't proceed with saving
        }
        trainingForm.set({...inputs, error : false, confirmation: true})
        console.log("Saving data:", inputs);
    }
	
    const handlerClose = () => {
        trainingForm.set({...inputs, confirmation: false})
    }
    
    const handlerSaving = async() => {
        trainingForm.set({...inputs, loader : true})
        const body = {
            id: inputs.id,
            user_id: userId.data,
            company_id: __SESSION.data.uaccess[0].company_id,
            training_name: inputs.training_name,
            training_date: inputs.training_date,
            training_start: inputs.training_start,
            training_end: inputs.training_end,
            training_fee: inputs.training_fee === 'free' ? 1 : 2,
			training_price: inputs.training_fee !== 'free' && payment,
            location: inputs.location,
            meeting_link: inputs.meeting_link,
            meeting_id: inputs.meeting_id,
            meeting_pass: inputs.meeting_pass,
            training_num: inputs.code,
            training_type: inputs.training_type === 'face_to_face' ? 1 : inputs.training_type === 'online' ? 2 : 3,
            active: inputs.active ? 1 : 0,
            show_shop: inputs.show_shop ? 1 : 0
        }
        const res = await rqx.post(`<<tool>>/${env()}/setupTraining/${inputs.method}`, body)
        if (res.message === 'success') {
			await readTrainings(1); // get fresh list from backend
            trainingForm.set({...inputs, loader : false, open: false, id: '', code: '', training_name: '', training_type: '', training_date: '', training_start: '', training_end: '', location: '', training_fee: 'free', training_price: '', meeting_link: '', meeting_id: '', meeting_pass: '', confirmation: false, error: false, method: 'create', active: false, show_shop: false,})
			paymentInfo.set([dfltPaymentInfo.data])
        }
    }
    
    return (
        <>
            <Dialog open={trainingForm.data.open} fullWidth PaperProps={{sx: {maxWidth: "1000px" }, }}>
                <Box display="flex"  flexDirection="column"  height="100%" maxHeight="90vh">
                    <Box p="24px" display="flex" flexDirection="column" gap="8px" className="overflowY" flexGrow={1}>
                        <Typography variant="h6" textAlign="center" fontWeight={600} fontSize={18}>
                            { inputs.method === 'create' ? 'Create' : 'Update'} Training Fee
                        </Typography>
                        <TextField size="small" label="Code" name="code" margin="dense" onChange={handlerChange} value={inputs.code} 
                            error={(!inputs.code || inputs.code.trim() === "") && inputs.error} disabled
                        />
                        <Typography color={inputs.training_type === '' && inputs.error ? "#f44336" : "#0009"} variant="body2" >
                            Training Type
                        </Typography>
                        <RadioGroup sx={{ display: 'flex', flexDirection: 'row'}} onChange={handlerChange} value={inputs.training_type}>
                            <FormControlLabel value="face_to_face" name="training_type" control={<Radio />} label="Face to Face" />
                            <FormControlLabel value="online" name="training_type" control={<Radio />} label="Online" />
                            <FormControlLabel value="f2f_online" name="training_type" control={<Radio />} label="Face to Face & Online" />
                        </RadioGroup>
                        <TextField size="small" label="Training Name" name="training_name" margin="dense" onChange={handlerChange} value={inputs.training_name} 
                            multiline rows={5} inputProps={{ maxLength: 255 }}
                            error={(!inputs.training_name || inputs.training_name.trim() === "") && inputs.error}
                        />
                        <TextField size="small" label="Date of Training" type="date" name="training_date" margin="dense" onChange={handlerChange} value={inputs.training_date} 
                            InputLabelProps={{shrink: true }}
                            error={(!inputs.training_date || inputs.training_date.trim() === "") && inputs.error}
                            inputProps={{ min: inputs.date_today }}
                        />
                        {/* #f44336 */}
                        <Typography color="#0009" variant="body2" >
                            Training Duration
                        </Typography>
                        <Box display="flex" gap="8px">
                            <TextField size="small" label="From" type="time" name="training_start" margin="dense" onChange={handlerChange} 
                                value={ inputs.training_start } 
                                InputLabelProps={{shrink: true }}
                                error={(!inputs.training_start || inputs.training_start.trim() === "") && inputs.error}
                            />
                            <TextField size="small" label="To" type="time" name="training_end" margin="dense" onChange={handlerChange} 
                                value={ inputs.training_end } 
                                InputLabelProps={{shrink: true }}
                                error={(!inputs.training_end || inputs.training_end.trim() === "") && inputs.error}
                            />
                        </Box>
                        <FormControl>
                            <Typography color="#0009" variant="body2" >
                                Training Fee
                            </Typography>
                            <Box display="flex" alignItems="center" justifyContent="space-between" gap="8px" flexWrap="wrap">
                                <RadioGroup sx={{ display: 'flex', flexDirection: 'row' }} onChange={handlerChange} value={inputs.training_fee}>
                                    <FormControlLabel value="free" name="training_fee"  control={<Radio />} label="Free" />
                                    <FormControlLabel value="with_payment" name="training_fee"  control={<Radio />} label="With Payment"/>
                                </RadioGroup>
								{ (inputs.training_fee === 'with_payment' && payment.length < 10) && 
									<Box onClick={handleAddFeeType} display='flex' alignItems='center' sx={{ cursor: 'pointer', borderRadius: '8px', transition: '0.25s', ':hover': { bgcolor: '#E7E8EA' } }}>
										<AddBox1 stroke='#003F2E' width={24} height={24}/>
									</Box>
								}
                            </Box>
                        </FormControl>
						{ inputs.training_fee === 'with_payment' && 
							<Payment setup_state={setup_state}/>
						}
						<TextField size="small" label="Location" name="location" margin="dense" onChange={handlerChange} value={inputs.location} 
							multiline rows={5} inputProps={{ maxLength: 1000 }}
							error={(!inputs.location || inputs.location.trim() === "") && inputs.error}
						/>
                        {
                            (inputs.training_type === 'online' || inputs.training_type === 'f2f_online') && 
                            <>    
                                <TextField size="small" label="Zoom Link" name="meeting_link" margin="dense" onChange={handlerChange} value={inputs.meeting_link} 
                                    error={(!inputs.meeting_link || inputs.meeting_link.trim() === "") && inputs.error}
                                />
                                <Box display="flex" gap="8px">
                                    <TextField size="small" label="Meeting ID" name="meeting_id" margin="dense" onChange={handlerChange} value={inputs.meeting_id} 
                                        error={(!inputs.meeting_id || inputs.meeting_id.trim() === "") && inputs.error}
                                    />
                                    <TextField size="small" label="Meeting Password" name="meeting_pass" margin="dense" onChange={handlerChange} value={inputs.meeting_pass} 
                                        error={(!inputs.meeting_pass || inputs.meeting_pass.trim() === "") && inputs.error}
                                    />
                                </Box>
                            </>
                        }
                        <Box display="flex" alignItems="center">
                            <Checkbox name="active" checked={inputs.active} onChange={handlerChange} />
                            <Typography>Active</Typography>
                        </Box>
                        <Box display="flex" alignItems="center">
                            <Checkbox name="show_shop" checked={inputs.show_shop} onChange={handlerChange} />
                            <Typography>Show in POFShop</Typography>
                        </Box>
                    </Box>
                    <Box display="flex" justifyContent="center" gap="16px" py="16px" borderTop="1px solid #ddd">
                        <Button variant="outlined" sx={{width: 100}} onClick={handlerCancel}>Cancel</Button>
                        <Button variant="contained" sx={{width: 100}} onClick={handlerSave}>{inputs.method === 'create' ? 'Save' : 'Update' }</Button>
                    </Box>
                </Box>
            </Dialog>
            {/* CONFIRMATION MODAL SAVING */}
            <Dialog open={inputs.confirmation} onClose={handlerClose}>
                <DialogTitle sx={{ fontSize: '18px', fontWeight: 600 }}>Confirm {inputs.method === 'create' ? 'Save' : 'Update'}</DialogTitle>
                <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>Are you sure you want to {inputs.method === 'create' ? 'save' : 'update'} this training?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handlerClose} disabled={inputs.loader}>Cancel</Button>
                    <Button onClick={handlerSaving} variant="contained" disabled={inputs.loader}>
                        {inputs.method === 'create' ? 'Save' : 'Update'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
